import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

const ForceReadOnlyPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.registerEditableListener(() => {
      editor.setEditable(false);
    });
    editor.setEditable(false);
  }, [editor]);

  return null;
};

export default ForceReadOnlyPlugin;
